import { render, staticRenderFns } from "./CampanhaMetas.vue?vue&type=template&id=dba4f412&scoped=true"
import script from "./CampanhaMetas.vue?vue&type=script&lang=js"
export * from "./CampanhaMetas.vue?vue&type=script&lang=js"
import style0 from "./CampanhaMetas.vue?vue&type=style&index=0&id=dba4f412&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba4f412",
  null
  
)

export default component.exports